/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

// note: types are uppercased in parseEngineAPI.ts
// and compared to the enum values here
export enum ReferenceType {
  CLASS = 'CLASS',
  DATATYPE = 'DATATYPE',
  ENUM = 'ENUM',
  GLOBAL = 'GLOBAL',
  LIBRARY = 'LIBRARY',
}

export enum MemberType {
  Callback = 'Callback',
  Constructor = 'Constructor',
  Event = 'Event',
  Function = 'Function',
  Method = 'Method',
  Property = 'Property',
  MathOperation = 'MathOperation',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
